import { frontendURL } from '../../../../helper/URLHelper';
import NewCampaign from './NewCampaign.vue';
import CampaignWizard from './CampaignWizard.vue'
import TemplateCampaign from './TemplateCampaign.vue'
import ScheduleCampaign from './ScheduleCampaign.vue'
import store from '../../../../store/index'
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');
const CampaignDetail = () => import('./CampaignDetail.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns-manager/campaign'),
      component: SettingsContent,
      props: {
        headerTitle: 'CAMPAIGN.HEADER',
        icon: 'arrow-swap',
      },
      children: [
        {
          path: '',
          redirect: "all"
        },

        {
          path: 'all',
          name: 'list_campaigns_all',
          roles: ['administrator'],
          component: Index,
          props: { status: -1 }
        },
        {
          path: 'draft',
          name: 'list_campaigns_draft',
          roles: ['administrator'],
          component: Index,
          props: { status: 0 }
        },
        {
          path: 'scheduled',
          name: 'list_campaigns_scheduled',
          roles: ['administrator'],
          component: Index,
          props: { status: 1 }
        },
        {
          path: 'in-progress',
          name: 'list_campaigns_in_progress',
          roles: ['administrator'],
          component: Index,
          props: { status: 2 }
        },

        {
          path: 'completed',
          name: 'list_campaigns_completed',
          roles: ['administrator'],
          component: Index,
          props: { status: 3 }
        },

        {
          path: 'failed',
          name: 'list_campaigns_failed',
          roles: ['administrator'],
          component: Index,
          props: { status: 4 }
        },
        {
          path: 'new',
          component: CampaignWizard,
          children: [
            {
              path: '',
              name: 'campaigns_new',
              component: NewCampaign,
              /*
              beforeEnter: (to, from, next) => {


                store.dispatch('campaignsManager/getFlows', {})
                  .then(() => {
                    store.dispatch('campaignsManager/getInboxes', {})
                      .then(() => {



                        next(); // Permite la navegación
                      })
                      .catch(() => {
                        next(false); // Cancela la navegación en caso de error
                      });





                  })
                  .catch(() => {
                    next(false); // Cancela la navegación en caso de error
                  });
              },*/
              roles: ['administrator'],
            },
            {
              path: 'template',
              name: 'campaigns_template',
              component: TemplateCampaign,
              roles: ['administrator'],

            },
            {
              path: 'schedule',
              name: 'campaigns_schedule',
              roles: ['administrator'],
              component: ScheduleCampaign,
            },
            {
              path: 'finish',
              name: 'campaigns_finish',
              roles: ['administrator'],
              component: ScheduleCampaign,
            },
          ],
        },
        {
          path: ':id',
          name: 'campaigns_detail',
          roles: ['administrator'],
          component: CampaignDetail,
          
        },


      ],
    }
  ],
};
